export const fileUploadProps = {
  SIZE_WARNING: "File must be smaller than 10MB!",
  PROGRESS_COLOR: "#87d068",
  HINT_1: "Click or drag a PDF file to this area to upload",
  HINT_2: "Max file size is 10MB",
};
